import { JSX, ReactElement } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    EditButton,
    TextField,
    SelectInput,
    DateInput,
    DateField,
    ReferenceField,
    required,
    useRecordContext,
    Pagination,
    useGetOne,
    List,
    Datagrid,
    WithRecord
} from 'react-admin';
import {
    Grid,
    Box,
} from '@mui/material';
import { emailFinderResultStatus } from "../../defaults/defaults";
import { EmailFinderResult } from "../../types/entities";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

const EmptyEmployee: () => JSX.Element = (): JSX.Element => {

    return (
        <Box sx={ {
            width: '100%',
            height: '300px',
            border: '1px solid', borderColor: 'divider',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        } }>
            <span>{ "No Contact Found..." }</span>
        </Box>
    );
}

export const EmailFinderResultsEdit: () => JSX.Element = (): JSX.Element => {

    // const { data: contact, isPending, error } = useGetOne('employee', { email: record.email });
    return (
        <Edit redirect={ false }>
            <SimpleForm >
                <Grid container spacing={ 2 } sx={ { width: '100%' } }>
                    <Grid size={ 6 }>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "ID" }</span>
                            <TextField source="id" />
                        </Box>
                        <TextInput name="name" source="name" validate={[required()]} />
                        <TextInput name="email" source="email" validate={[required()]} />
                        <TextInput name="department" source="department" />
                        <TextInput name="location" source="location"  />
                        <TextInput name="url" source="url" validate={[required()]} />
                        <SelectInput source="status" choices={ emailFinderResultStatus } validate={[required()]} />
                    </Grid>
                    <Grid size={ 6 }>
                        <TextInput name="telephone" source="telephone" />
                        <TextInput name="pageTitle" source="pageTitle" />
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } } >
                            <span>{ "Created" }</span>
                            <DateField source="createdAt" showTime />
                        </Box>
                        <Box sx={ {
                            display: 'flex',
                            justifyContent: 'space-between'
                        } }>
                            <span>{ "EmailFinder" }</span>
                            <ReferenceField source="emailFinder"  reference="email_finders" >
                                <TextField source='name' />
                            </ReferenceField>
                        </Box>
                        <Box sx={ {
                            display: 'flex',
                            flexDirection: 'Column',
                            margin: '40px 0 0 0',
                            padding: '20px 0 0 0',
                            borderTop: '1px solid', borderTopColor: 'divider'
                        } }>
                            <span>{ "Created Contact" }</span>
                            <WithRecord render={
                                (record: EmailFinderResult): ReactElement => {
                                    return (
                                        <List resource="employees"
                                              actions={ false }
                                              title=" "
                                              pagination={ false }
                                              empty={ <EmptyEmployee /> }
                                              filter={ {
                                                  email: record?.email
                                              } }
                                        >
                                            <Datagrid bulkActionButtons={ false }>
                                                <TextField source="id" />
                                                <TextField source="name" />
                                                <EditButton label="View" />
                                            </Datagrid>
                                        </List>
                                    );
                                }
                            } />
                        </Box>
                    </Grid>
                </Grid>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}
